export default "__VITE_ASSET__BBTzAWRP__"